import mix from '@utils/styles/mix'
import styles from 'styles/DisplaySection.module.css'

const DisplaySection = ({ children, gray, borders }) => (
    <section className={mix([
        gray
            ? styles.gray
            : styles.white,

        borders && styles.borders
    ])}>
        <div className="container relative">
            {children}
        </div>
    </section>
)

DisplaySection.MinHeight = ({children})=><div className="min-height">{children}</div>

export default DisplaySection